import { Component } from '@angular/core';

@Component({
    selector: 'app-common-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent {
}
